import { render, staticRenderFns } from "./FinalRanking.vue?vue&type=template&id=9d82b14c&scoped=true&"
import script from "./FinalRanking.vue?vue&type=script&lang=js&"
export * from "./FinalRanking.vue?vue&type=script&lang=js&"
import style0 from "./FinalRanking.vue?vue&type=style&index=0&id=9d82b14c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d82b14c",
  null
  
)

export default component.exports